import styled from 'styled-components/macro';
import { easyMoveX, COLORS } from 'styleguide';

const Logout = styled.div`
  animation: ${easyMoveX} 0.25s ease-out;
  position: absolute;
  left: 105px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px 24px;
  margin-bottom: 8px;
  border-radius: 4px;
  background-color: ${COLORS.black};
  z-index: 1;
`;

export default Logout;
